module.exports = __webpack_public_path__ + "img/slider-thumb.50eaf3f7.jpg";